export class EntityNotFoundError extends Error {
    constructor(entityName: string) {
        super(`Entity configuration for '${entityName}' not found.`);
        this.name = "EntityNotFoundError";
    }
}

export class InvalidEntityEndpointError extends Error {
    constructor(entityName: string) {
        super(`Entity endpoint for '${entityName}' is not a valid URL.`);
        this.name = "InvalidEntityEndpointError";
    }
}